<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    大运站<br>
站点介绍<br>
大运地铁站位于龙岗大道中与龙飞大道东交汇处。东侧有大运软件小镇，西侧公交站场，西北是颐安都会中央商住楼，西南有顺逸来酒店。大运站周边大概汇聚20个小区，8所学校，距离COCO PARK商圈500米左右，西行1公里左右到达大运场馆。该站位为高架站。
运营时刻表(工作日)<br><br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	23:12	3号线	2分15-20秒	4分30秒<br>
双龙	06:12	00:00	3号线	2分15-20秒	4分30秒<br>
岗厦北	06:29	23:27	14号线	4分30秒	6分15秒<br>
沙田	06:27	23:57	14号线	4分30秒	6分15秒<br>
大运	06:00	23:00	16号线	5分32秒	6分32秒<br>
田心	--	--	16号线	5分32秒	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	23:11	3号线	3分15秒	5分钟<br>
双龙	06:15	00:00	3号线	3分15秒	5分钟<br>
岗厦北	06:27	23:27	14号线	5分25秒	6分15秒<br>
沙田	06:27	23:57	14号线	5分25秒	6分15秒<br>
大运	06:00	23:00	16号线	5分50秒	6分钟-9分钟<br>
田心	--		16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	00:11	3号线	3分15秒	5分钟<br>
双龙	06:15	01:00	3号线	3分15秒	5分钟<br>
岗厦北	06:27	00:27	14号线	5分钟	6分15秒<br>
沙田	06:27	00:57	14号线	5分钟	6分15秒<br>
大运	06:00	00:00	16号线	5分50秒	6分钟-9分钟<br>
田心	--	--	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙岗大道东侧（南）、莲塘尾工业区、深圳大学龙岗创新研究院、深圳软件园龙岗分园、水荷立交、仁恒置地<br><br>
C出入口:<br>
龙岗大道西侧（北）、龙飞大道、大运会场馆、深圳信息职业技术学院、桂坪路、龙岗星河COCOPark、龙城水厂、大运地铁接驳站、星河时代、颐安都会中央<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 大运地铁站<br>
351、358、833、923、M136、M314、M322、M396、M466、E23、E33、E34、M229、M239、M266、M294、M316、M303、M357C出入口<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shisihaoxian",
          title: "14号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiliuhaoxian",
          title: "16号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


